
// // AdminLayout.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { 
//   faBars, 
//   faUserCircle,
//   faSignOutAlt,
//   faUsers,
//   faBook,
//   faFileAlt,
//   faCalendarAlt,
//   faEnvelope,
//   faTachometerAlt,
//   faTimes
// } from "@fortawesome/free-solid-svg-icons";
// import { useAuth } from "../../context/AuthContext";

// const AdminLayout = ({ children }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const { logout, user } = useAuth();
//   const location = useLocation();
//   const sidebarRef = useRef();

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 768;
//       setIsMobile(mobile);
//       if (!mobile) {
//         setSidebarOpen(true);
//       } else {
//         setSidebarOpen(false);
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobile && sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         setSidebarOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isMobile, sidebarOpen]);

//   const menuItems = [
//     { path: "/admin/dashboard", label: "Dashboard", icon: faTachometerAlt },
//     { path: "/admin/create-team", label: "Team Members", icon: faUsers },
//     { path: "/admin/create-blog", label: "Blogs", icon: faBook },
//     { path: "/admin/create-case-study", label: "Case Studies", icon: faFileAlt },
//     { path: "/admin/query", label: "All Query", icon: faCalendarAlt },
//     { path: "/admin/payment", label: "All Payment", icon: faEnvelope },

//   ];

//   const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

//   const handleLogout = () => {
//     logout();
//   };

//   return (
//     <div className="h-screen flex overflow-hidden bg-gray-50">
//       {/* Sidebar Overlay for mobile */}
//       {isMobile && sidebarOpen && (
//         <div 
//           className="fixed inset-0 bg-black bg-opacity-50 z-20"
//           onClick={() => setSidebarOpen(false)}
//         ></div>
//       )}

//       {/* Sidebar - Fixed position */}
//       <aside
//         ref={sidebarRef}
//         className={`fixed md:relative z-30 bg-gradient-to-b from-gray-900 to-gray-800 text-white transition-all duration-300 ease-in-out flex flex-col h-full ${
//           sidebarOpen ? "translate-x-0 w-64" : "-translate-x-full w-64"
//         } md:translate-x-0`}
//         style={{ height: '100vh', overflowY: 'auto' }}
//       >
//         {/* Logo Area - Sticky */}
//         <div className="sticky top-0 bg-gradient-to-b from-gray-900 to-gray-800 z-10">
//           <div className="flex items-center justify-between p-1">
          
//             {isMobile && (
//               <button
//                 onClick={toggleSidebar}
//                 className="p-1 rounded-lg hover:bg-gray-700 transition-colors"
//               >
//                 <FontAwesomeIcon icon={faTimes} className="text-white" />
//               </button>
//             )}
//           </div>

//           {/* User Profile */}
//           <div className="flex flex-col items-center p-1 border-b border-gray-700">
//             <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mb-3">
//               <FontAwesomeIcon icon={faUserCircle} className="text-white text-3xl" />
//             </div>
//             <h3 className="text-lg font-semibold text-white">Admin User</h3>
//             <p className="text-sm text-gray-400">{user?.email || "info@deetyasoft.com"}</p>
//           </div>
//         </div>

//         {/* Navigation Menu - Scrollable */}
//         <nav className="flex-1 p-4 overflow-y-auto">
//           <ul className="space-y-2">
//             {menuItems.map((item, index) => {
//               const isActive = location.pathname === item.path;
//               return (
//                 <li key={index}>
//                   <Link
//                     to={item.path}
//                     className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-all duration-200 ${
//                       isActive
//                         ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
//                         : "text-gray-300 hover:bg-gray-700 hover:text-white"
//                     }`}
//                   >
//                     <FontAwesomeIcon icon={item.icon} className="w-5 h-5" />
//                     <span className="text-sm font-medium">{item.label}</span>
//                   </Link>
//                 </li>
//               );
//             })}
//           </ul>
//         </nav>

//         {/* Logout Button - Sticky Bottom */}
//         <div className="sticky bottom-0 p-2 border-t border-gray-700 bg-gradient-to-b from-gray-800 to-gray-900">
//           <button
//             onClick={handleLogout}
//             className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-red-600 hover:text-white transition-all duration-200"
//           >
//             <FontAwesomeIcon icon={faSignOutAlt} className="w-5 h-5" />
//             <span className="text-sm font-medium">Logout</span>
//           </button>
//         </div>
//       </aside>

//       {/* Main Content Area */}
//       <div className="flex-1 flex flex-col h-full overflow-hidden">
//         {/* Top Navbar - Fixed */}
//         <header className="bg-white shadow-sm sticky top-0 z-10 flex-shrink-0">
//           <div className="px-4 py-3 flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={toggleSidebar}
//                 className="p-2 rounded-lg hover:bg-gray-100 transition-colors md:hidden"
//               >
//                 <FontAwesomeIcon icon={faBars} className="text-gray-700 text-xl" />
//               </button>
             
//             </div>

//             <div className="flex items-center space-x-4">
//               <div className="flex items-center space-x-3">
//                 <div className="text-right hidden sm:block">
//                   <p className="text-sm font-semibold text-gray-800">Admin User</p>
//                   <p className="text-xs text-gray-500">{user?.email || "info@deetyasoft.com"}</p>
//                 </div>
//                 <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
//                   <FontAwesomeIcon icon={faUserCircle} className="text-white text-xl" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </header>

//         {/* Page Content - Scrollable */}
//         <main className="flex-1 overflow-y-auto p-2">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;


// AdminLayout.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { 
//   faBars, 
//   faUserCircle,
//   faSearch,
//   faBell,
//   faChevronDown,
//   faChevronLeft,
//   faChevronRight
// } from "@fortawesome/free-solid-svg-icons";
// import { useAuth } from "../../context/AuthContext";
// import Sidebar from "./Sidebar";

// const AdminLayout = ({ children }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isMobile, setIsMobile] = useState(false);
//   const { user } = useAuth();
//   const sidebarRef = useRef();

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 768;
//       setIsMobile(mobile);
//       if (mobile) {
//         setSidebarOpen(false);
//       } else {
//         setSidebarOpen(true);
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobile && sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         setSidebarOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isMobile, sidebarOpen]);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   const closeSidebar = () => {
//     if (isMobile) {
//       setSidebarOpen(false);
//     }
//   };

//   return (
//     <div className="h-screen flex overflow-hidden bg-gray-50">
//       {/* Sidebar Overlay for mobile */}
//       {isMobile && sidebarOpen && (
//         <div 
//           className="fixed inset-0 bg-black bg-opacity-50 z-20"
//           onClick={closeSidebar}
//         ></div>
//       )}

//       {/* Sidebar */}
//       <div
//         ref={sidebarRef}
//         className={`${
//           isMobile 
//             ? `fixed top-0 left-0 z-30 h-full transition-transform duration-300 ease-in-out ${
//                 sidebarOpen ? "translate-x-0" : "-translate-x-full"
//               } w-64 flex-shrink-0`
//             : `relative z-30 h-full transition-all duration-300 ease-in-out ${
//                 sidebarOpen ? "w-64" : "w-1"
//               } flex-shrink-0`
//         }`}
//       >
//         <Sidebar onClose={closeSidebar} isOpen={sidebarOpen} isMobile={isMobile} />
//       </div>

//       {/* Main Content Area */}
//       <div className="flex-1 flex flex-col h-full overflow-hidden">
//         {/* Top Navbar */}
//         <header className="bg-white shadow-sm z-10 flex-shrink-0">
//           <div className="px-4 py-3 flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               {/* Mobile menu button */}
//               <button
//                 onClick={toggleSidebar}
//                 className="p-2 rounded-lg hover:bg-gray-100 transition-colors md:hidden"
//               >
//                 <FontAwesomeIcon icon={faBars} className="text-gray-700 text-xl" />
//               </button>
              
//               {/* Desktop toggle button - NEW */}
//               {!isMobile && (
//                 <button
//                   onClick={toggleSidebar}
//                   className="p-2 rounded-lg hover:bg-gray-100 transition-colors hidden md:flex items-center justify-center"
//                   title={sidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
//                 >
//                   <FontAwesomeIcon 
//                     icon={sidebarOpen ? faChevronLeft : faChevronRight} 
//                     className="text-gray-700 text-xl" 
//                   />
//                 </button>
//               )}
              
//               {/* Search Bar - Desktop */}
//               <div className="hidden md:flex items-center bg-gray-100 rounded-lg px-3 py-2 min-w-[300px]">
//                 <FontAwesomeIcon icon={faSearch} className="text-gray-400 mr-2" />
//                 <input
//                   type="text"
//                   placeholder="Search..."
//                   className="bg-transparent border-none focus:outline-none text-sm w-full"
//                 />
//               </div>
//             </div>

//             <div className="flex items-center space-x-4">
//               {/* Notification Bell */}
//               <button className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors">
//                 <FontAwesomeIcon icon={faBell} className="text-gray-600 text-xl" />
//                 <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
//               </button>

//               {/* User Menu */}
//               <div className="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 rounded-lg p-2 transition-colors">
//                 <div className="text-right hidden sm:block">
//                   <p className="text-sm font-semibold text-gray-800">Admin User</p>
//                   <p className="text-xs text-gray-500">{user?.email || "info@deetyasoft.com"}</p>
//                 </div>
//                 <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
//                   <FontAwesomeIcon icon={faUserCircle} className="text-white text-xl" />
//                 </div>
//                 <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-sm hidden sm:block" />
//               </div>
//             </div>
//           </div>

//           {/* Search Bar - Mobile */}
//           <div className="md:hidden px-4 pb-3">
//             <div className="flex items-center bg-gray-100 rounded-lg px-3 py-2">
//               <FontAwesomeIcon icon={faSearch} className="text-gray-400 mr-2" />
//               <input
//                 type="text"
//                 placeholder="Search..."
//                 className="bg-transparent border-none focus:outline-none text-sm w-full"
//               />
//             </div>
//           </div>
//         </header>

//         {/* Page Content */}
//         <main className="flex-1 overflow-y-auto p-1">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;

// AdminLayout.jsx
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faBars, 
  faUserCircle,
  faSearch,
  faBell,
  faChevronDown,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "./Sidebar";

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const { user } = useAuth();
  const sidebarRef = useRef();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile, sidebarOpen]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="h-screen flex overflow-hidden bg-gray-50">
      {/* Sidebar Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={closeSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`${
          isMobile 
            ? `fixed top-0 left-0 z-30 h-full transition-transform duration-300 ease-in-out ${
                sidebarOpen ? "translate-x-0" : "-translate-x-full"
              } w-64 flex-shrink-0`
            : `relative z-30 h-full transition-all duration-300 ease-in-out ${
                sidebarOpen ? "w-64" : "w-20"
              } flex-shrink-0`
        }`}
      >
        <Sidebar onClose={closeSidebar} isOpen={sidebarOpen} isMobile={isMobile} />
      </div>

      {/* Main Content Area - Adjust margin based on sidebar state */}
      <div 
        className={`flex-1 flex flex-col h-full overflow-hidden transition-all duration-300 ease-in-out ${
          !isMobile && !sidebarOpen ? "md:ml-0" : ""
        }`}
      >
        {/* Top Navbar */}
        <header className="bg-white shadow-sm z-10 flex-shrink-0">
          <div className="px-4 py-3 flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {/* Mobile menu button */}
              <button
                onClick={toggleSidebar}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors md:hidden"
              >
                <FontAwesomeIcon icon={faBars} className="text-gray-700 text-xl" />
              </button>
              
              {/* Desktop toggle button */}
              {!isMobile && (
                <button
                  onClick={toggleSidebar}
                  className="p-2 rounded-lg hover:bg-gray-100 transition-colors hidden md:flex items-center justify-center"
                  title={sidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
                >
                  <FontAwesomeIcon 
                    icon={sidebarOpen ? faChevronLeft : faChevronRight} 
                    className="text-gray-700 text-xl" 
                  />
                </button>
              )}
              
              {/* Search Bar - Desktop */}
              <div className="hidden md:flex items-center bg-gray-100 rounded-lg px-3 py-2 min-w-[300px]">
                <FontAwesomeIcon icon={faSearch} className="text-gray-400 mr-2" />
                <input
                  type="text"
                  placeholder="Search..."
                  className="bg-transparent border-none focus:outline-none text-sm w-full"
                />
              </div>
            </div>

            <div className="flex items-center space-x-4">
              {/* Notification Bell */}
              <button className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <FontAwesomeIcon icon={faBell} className="text-gray-600 text-xl" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>

              {/* User Menu */}
              <div className="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 rounded-lg p-2 transition-colors">
                <div className="text-right hidden sm:block">
                  <p className="text-sm font-semibold text-gray-800">Admin User</p>
                  <p className="text-xs text-gray-500">{user?.email || "info@deetyasoft.com"}</p>
                </div>
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                  <FontAwesomeIcon icon={faUserCircle} className="text-white text-xl" />
                </div>
                <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-sm hidden sm:block" />
              </div>
            </div>
          </div>

          {/* Search Bar - Mobile */}
          <div className="md:hidden px-4 pb-3">
            <div className="flex items-center bg-gray-100 rounded-lg px-3 py-2">
              <FontAwesomeIcon icon={faSearch} className="text-gray-400 mr-2" />
              <input
                type="text"
                placeholder="Search..."
                className="bg-transparent border-none focus:outline-none text-sm w-full"
              />
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-1">
          <div className="max-w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;